import { testReviewStates } from '@constants/index';
import { quizTypes } from '../constants';

const initialState = {
  quizData: {},
  reviewData: {},
  evaluationData: {},
  leaderboard: {},
  attempts: {},
  sessionData: {},
  questionReportOptions: {},
  solutionReportOptions: {},
  solutionFilters: [],
  testFeedbackOptions: {},
  quizRank: null,
  sessionDetails: {},
  questions: {},
  isFetching: false,
  isSubmitting: false,
  mappedGoals: [],
  reviewNotfications: [],
  dashboardFilter: 'pending',
  dashboardLanguage: null,
  availableLanguages: [],
  sortingOrder: { label: 'Recent first', value: 'recent_first' },
  selectedGoal: null,
  evalDashStats: {},
  evalQuestions: [],
  testSeries: {},
  evalCriteria: [],
  performanceStats: {},
  feedbackChoices: [],
  isEditing: false,
  uploadDashboardGoals: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${quizTypes.FETCH_QUIZ_DETAILS}_SUCCESS`:
      return {
        ...state,
        sessionUid: action.result ? action.result.user_active_session : null,
        quizData: {
          ...state.quizData,
          [action.quizUid]: action.result
        }
      };
    case `${quizTypes.FETCH_MY_QUIZ_ATTEMPTS}_SUCCESS`:
      return {
        ...state,
        leaderboard: {
          ...state.leaderboard,
          [action.quizUid]: action.result
        }
      };
    case 'RESET_SESSION_DATA':
      return {
        ...state,
        sessionData: {},
        sessionUid: null
      };
    case `${quizTypes.ENROLL_IN_QUIZ}_SUCCESS`:
      return {
        ...state,
        sessionUid: action.result?.uid,
        sessionData: action.result
      };
    case `${quizTypes.FETCH_QUESTIONS}_SUCCESS`:
      return {
        ...state,
        sessionData: action.result
      };

    case 'FINISH_SECTION_SUCCESS':
      return {
        ...state,
        sessionData: {
          ...state.sessionData,
          ongoing_section_details: action.result
        }
      };

    case `${quizTypes.FETCH_QUESTION_REPORT_OPTIONS}_SUCCESS`:
      return {
        ...state,
        questionReportOptions: action.result
      };

    case `${quizTypes.FETCH_SOLUTION_FEEDBACK_OPTIONS}_SUCCESS`:
      return {
        ...state,
        solutionReportOptions: action.result
      };

    case `${quizTypes.FETCH_QUIZ_RESULTS}_SUCCESS`:
      return {
        ...state,
        quizReport: action.result
      };

    case `${quizTypes.FETCH_QUIZ_DETAILED_RESULTS}_SUCCESS`:
      return {
        ...state,
        detailedSolutionReport: action.result
      };

    case `${quizTypes.FETCH_SOLUTION_FILTERS}_SUCCESS`:
      return {
        ...state,
        solutionFilters: action.result
      };

    case `${quizTypes.FETCH_TEST_FEEDBACK_OPTIONS}_SUCCESS`:
      return {
        ...state,
        testFeedbackOptions: action.result
      };

    case `${quizTypes.FETCH_SESSION_DETAILS}_SUCCESS`:
      return {
        ...state,
        sessionDetails: action.result
      };

    case `${quizTypes.FETCH_QUIZ_RANK}_SUCCESS`:
      return {
        ...state,
        quizRank: action.result?.rank
      };
    // quiz creation -->

    case `${quizTypes.FETCH_QUIZ_DATA}_REQUEST`:
      return { ...state, isFetching: true };

    case `${quizTypes.FETCH_QUIZ_DATA}_SUCCESS`: {
      if (action.store)
        return {
          ...state,
          isFetching: false,
          quizData: {
            ...state.quizData,
            [action.quizUID]: action.result
          }
        };
      return { ...state, isFetching: false };
    }

    case `${quizTypes.FETCH_QUIZ_DATA}_FAILURE`:
      return { ...state, isFetching: false };

    case `${quizTypes.FETCH_SESSION_QUESTIONS}_SUCCESS`:
      return {
        ...state,
        questions: { ...state.questions, [action.sectionUID]: action.result }
      };

    case `${quizTypes.FETCH_REVIEW_STATS}_SUCCESS`:
      return {
        ...state,
        reviewStats: {
          ...state.reviewStats,
          [action.goalUID]: action.result
        }
      };

    case `${quizTypes.MARK_PDF_UPLOADED}_SUCCESS`:
      return {
        ...state,
        quizData: {
          ...state.quizData,
          [action.quizUID]: {
            ...state.quizData[action.quizUID],
            pdf_uploaded: action.pdf_url
          }
        }
      };

    case `${quizTypes.DELETE_SUBJECTIVE_PDF}_SUCCESS`:
      return {
        ...state,
        quizData: {
          ...state.quizData,
          [action.quizUID]: {
            ...state.quizData[action.quizUID],
            pdf_uploaded: null
          }
        }
      };

    case `${quizTypes.FETCH_DASHBOARD_GOALS}_SUCCESS`:
      return { ...state, mappedGoals: action.result };

    case quizTypes.UPDATE_DASHBOARD_FILTERS:
      return {
        ...state,
        dashboardFilter: action.state || state.dashboardFilter,
        selectedGoal: action.goal || state.selectedGoal,
        sortingOrder: action.sort || state.sortingOrder,
        dashboardLanguage: action.language || state.dashboardLanguage
      };

    case `${quizTypes.FETCH_REVIEW_DETAILS}_SUCCESS`:
      return {
        ...state,
        reviewData: { ...state.reviewData, [action.reviewUID]: action.result }
      };

    case `${quizTypes.FINISH_REVIEW}_SUCCESS`:
      return {
        ...state,
        reviewData: {
          ...state.reviewData,
          [action.reviewUID]: {
            ...state.reviewData[action.reviewUID],
            state: testReviewStates.COMPLETED
          }
        }
      };

    case `${quizTypes.FETCH_REVIEW_NOTIFICATIONS}_SUCCESS`:
      return { ...state, reviewNotfications: action.result };

    case `${quizTypes.FETCH_EVAL_DASH_STATS}_SUCCESS`:
      return {
        ...state,
        evalDashStats: {
          ...state.evalDashStats,
          [action.goalUID]: action.result
        }
      };

    case `${quizTypes.FETCH_EVAL_DASH_GOALS}_SUCCESS`:
      return {
        ...state,
        mappedGoals: action.result.goals,
        availableLanguages: action.result.languages
      };

    case `${quizTypes.FETCH_EVAL_DETAILS}_SUCCESS`:
      return {
        ...state,
        evaluationData: {
          ...state.evaluationData,
          [action.evaluationUID]: action.result
        }
      };

    case `${quizTypes.FETCH_TEST_SERIES_DATA}_SUCCESS`:
      return {
        ...state,
        testSeries: {
          ...state.testSeries,
          [action.testSeriesKey]: action.result
        }
      };

    case `${quizTypes.FETCH_FEEDBACK_CHOICES}_SUCCESS`:
      return {
        ...state,
        isSubmitting: false,
        feedbackChoices: action.result
      };

    case `${quizTypes.CREATE_UPDATE_ISSUES}_REQUEST`:
    case `${quizTypes.FETCH_FEEDBACK_CHOICES}_REQUEST`:
    case `${quizTypes.FETCH_EVALUATION_CRITERIA}_REQUEST`:
    case `${quizTypes.SUBMIT_SCORE}_REQUEST`:
      return {
        ...state,
        isSubmitting: true
      };

    case `${quizTypes.FETCH_EVALUATION_CRITERIA}_SUCCESS`:
      return {
        ...state,
        isSubmitting: false,
        evalCriteria: action.result.evaluation_criteria,
        performanceStats: action.result.performance_statistics
      };

    case `${quizTypes.SUBMIT_SCORE}_SUCCESS`:
    case `${quizTypes.SUBMIT_SCORE}_FAILURE`:
    case `${quizTypes.CREATE_UPDATE_ISSUES}_SUCCESS`:
    case `${quizTypes.CREATE_UPDATE_ISSUES}_FAILURE`:
    case `${quizTypes.FETCH_FEEDBACK_CHOICES}_FAILURE`:
    case `${quizTypes.FETCH_EVALUATION_CRITERIA}_FAILURE`:
      return {
        ...state,
        isSubmitting: false
      };

    case quizTypes.ASSIGN_MARKS:
    case quizTypes.MARK_SKIPPED:
      return { ...state, isEditing: true };

    case `${quizTypes.SUBMIT_EVALUATION_SCORE}_SUCCESS`:
    case `${quizTypes.SKIP_EVALUATION_FEEDBACK}_SUCCESS`:
      return { ...state, isEditing: false };

    case `${quizTypes.FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS}_SUCCESS`:
      return {
        ...state,
        uploadDashboardGoals: action.result
      };

    case `${quizTypes.UPDATE_QUIZ_INSTRUCTIONS}`:
      return {
        ...state,
        quizData: {
          ...state.quizData,
          [action.data.quizUID]: {
            ...state.quizData[action.data.quizUID],
            instructions: action.data.instructions
          }
        }
      };

    default:
      return state;
  }
};

export default reducer;
